import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { FaqComponent } from './faq/faq.component';
import { CollaboratorsComponent } from './collaborators/collaborators.component';
import { HomeComponent } from './home/home.component';
import { SearchComponent } from './search/search.component';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';
import { securityGuard } from './security.guard'; // Import the guard

// AFPDBE-1376: the new download page is blocked on a backend issue. While that's
// unresolved, /download serves the restored legacy page instead. Flip this back
// to false (and redeploy) once the backend issue is fixed and the new page is ready.
const USE_OLD_DOWNLOAD_PAGE = true;

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'api-docs', loadComponent: () => import('./swagger/swagger.component').then(m => m.SwaggerComponent) },
  // Eager, not lazy: this is a small static/text page (no API calls, no heavy
  // visualizations — same as about/faq above), so there's no bundle-size cost worth
  // paying for code-splitting it. It also means a stale-chunk failure (a build going out
  // on the server while the user has an old page open — AFPDBE-1418) can never happen
  // for this route, since it ships in the main bundle rather than being fetched later.
  { path: 'collaborators', component: CollaboratorsComponent },
  { path: 'release-notes', component: ReleaseNotesComponent },
  
  // SECURE ROUTES: These will trigger reCAPTCHA on every click
  {
    path: 'download',
    loadComponent: () => USE_OLD_DOWNLOAD_PAGE
      ? import('./download-legacy/download-legacy.component').then(m => m.DownloadLegacyComponent)
      : import('./download/download.component').then(m => m.DownloadComponent),
    canActivate: [securityGuard]
  },
  {
    path: 'entry/:id/:test',
    loadChildren: () => import('./entry.module').then((m) => m.EntryModule),
    canActivate: [securityGuard]
  },
  {
    path: 'entry/:id',
    loadChildren: () => import('./entry.module').then((m) => m.EntryModule),
    canActivate: [securityGuard]
  },
  { 
    path: 'search/:field/:term', 
    component: SearchComponent, 
    canActivate: [securityGuard] 
  },
  { 
    path: 'latest', 
    component: SearchComponent,
    data: { isLatest: true },
    canActivate: [securityGuard]  
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollOffset: [0, 0],
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}